import { ModalStateNames } from '~/utils/constants/modalStateNames';

export default {
  HANDLE_SHOW_CREATE_POST_MODAL: (state, payload) => {
    if (!state.showCreatePostModal.show) {
      state.openModals.push(ModalStateNames.CreatePostModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.CreatePostModal
      );
    }
    state.showCreatePostModal = {
      ...{
        title: '',
        mentionPost: null,
        originalPost: null,
        callback: null,
        dispatch: null,
        context: null,
        league: null,
      },
      ...payload,
      show: state.showCreatePostModal.show,
    };

    if (payload && 'transactionData' in payload) {
      state.showCreatePostModal.transactionData = payload.transactionData;
    }

    if (payload && 'league' in payload) {
      state.showCreatePostModal.league = payload.league;
    }
    state.showCreatePostModal.show = !state.showCreatePostModal.show;
  },
  HANDLE_SHOW_IMAGE_SLIDER_MODAL: (state, payload) => {
    if (!state.showImageSliderModal.show) {
      state.openModals.push(ModalStateNames.ImageSliderModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.ImageSliderModal
      );
    }
    state.showImageSliderModal = {
      navigateTo: 0,
      ...payload,
      show: state.showImageSliderModal.show,
    };
    state.showImageSliderModal.show = !state.showImageSliderModal.show;
  },
  HANDLE_SHOW_CREATE_PORTFOLIO_MODAL: (state, payload) => {
    if (!state.createPortfolioModal.show) {
      state.openModals.push(ModalStateNames.CreatePortfolioModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.CreatePortfolioModal
      );
    }
    state.createPortfolioModal.isLeaguePortfolio = !!payload?.leagueId;
    state.createPortfolioModal.leagueId = payload?.leagueId;
    state.createPortfolioModal.league = payload?.league;
    state.createPortfolioModal.invitationId = payload?.invitationId;
    state.createPortfolioModal.show = !state.createPortfolioModal.show;
  },
  HANDLE_TOGGLE_LEGAL_DISCLAIMER_MODAL: (state) => {
    if (!state.showLegalDisclaimerModal) {
      state.openModals.push(ModalStateNames.LegalDisclaimerModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.LegalDisclaimerModal
      );
    }
    state.showLegalDisclaimerModal = !state.showLegalDisclaimerModal;
  },
  HANDLE_SHOW_SELECT_PROFILE_MODAL: (state) => {
    state.showSelectProfileModal = !state.showSelectProfileModal;
  },

  HIDE_MENTION_CARD_DONE: (state) => {
    state.currentMentionCard = null;
  },
  MOUSE_ENTER_MENTION_CARD: (state) => {
    state.currentMentionCard = { ...state.currentMentionCard };
  },
  SET_MENTION_HOVERED: (state, isHovered) => {
    state.mentionHovered = isHovered;
  },
  SET_MENTION_HOVERED_ID: (state, id) => {
    state.hoveredMentionId = id;
  },
  SET_MENTION_CARD_HOVERED: (state, isHovered) => {
    state.mentionCardHovered = isHovered;
  },
  SET_MENTION_CARD_HOVERED_ID: (state, id) => {
    state.hoveredMentionCardId = id;
  },
  MOUSE_LEAVE_MENTION_CARD: (state) => {
    state.currentMentionCard = { ...state.currentMentionCard };
  },
  SET_MENTION_CARD_PROFILE: (state, profile) => {
    if (!state.currentMentionCard) {
      state.currentMentionCard = { profile: profile, isLoading: true };
    } else {
      state.currentMentionCard.profile = profile;
      state.currentMentionCard.isLoading = true;
    }
    state.currentMentionCard = { ...state.currentMentionCard };
    state.lastMentionCard = state.currentMentionCard;
  },
  SET_MENTION_CARD_POS: (state, pos) => {
    if (!state.currentMentionCard) {
      state.currentMentionCard = { pos: pos, isLoading: true };
    } else {
      state.currentMentionCard.pos = pos;
      state.currentMentionCard.isLoading = true;
    }
    state.currentMentionCard = { ...state.currentMentionCard };
    state.lastMentionCard = state.currentMentionCard;
  },
  SET_MENTION_CARD_LAST_MENTION_CARD: (state) => {
    state.currentMentionCard = state.lastMentionCard;
  },
  SET_MENTION_CARD_LOADING: (state, isLoading) => {
    state.currentMentionCard.isLoading = isLoading;
    state.currentMentionCard = { ...state.currentMentionCard };
  },
  SET_MENTION_CARD_ERROR: (state, err) => {
    console.error(err);
  },
  SET_MENTION_CARD_IS_FOLLOWED: (state, isFollowed) => {
    state.currentMentionCard.profile.isFollowed = isFollowed;
    state.currentMentionCard = { ...state.currentMentionCard };
  },
  MOUSE_LEAVE_MENTION: (state) => {
    state.currentMentionCard = { ...state.currentMentionCard };
  },
  SET_SHOW_PASSWORD_RESET(state, show) {
    if (show) {
      state.openModals.push(ModalStateNames.PasswordResetModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PasswordResetModal
      );
    }
    state.passwordResetModal.show = show;
  },
  PASSWORD_RESET_NEXT_STEP(state) {
    state.passwordResetModal.step++;
  },
  INIT_PASSWORD_RESET(state) {
    state.passwordResetModal = {
      show: false,
      step: 1,
    };
  },

  // Add operation modal
  RESET_CREATE_PORTFOLIO_OPERATION_MODAL: (state) => {
    const index = state.openModals.indexOf(ModalStateNames.TransactionModal);
    if (index !== -1) state.openModals.splice(index, 1);
    state.createPortfolioOperationModal = {
      show: false,
      portfolioType: null,
      symbol: null,
      portfolio: null,
      operationType: 'Buy',
      symbolLoading: false,
      symbolError: null,
      createOperationError: null,
      createCashOperationError: null,
      tickerValue: null,
      isCashTransaction: false,
      currency: '',
      isSubmitting: false,
      multipleTransactions: false,
      leagueId: null,
      league: null,
      invitationId: null,
      shouldCheckForLineRule: true,
      shouldShowTickerCard: true,
    };
  },
  RESET_CREATE_ORDER_OPERATION_MODAL: (state) => {
    const index = state.openModals.indexOf(ModalStateNames.OrderBookModal);
    if (index !== -1) state.openModals.splice(index, 1);
    state.createOrderTransactionModal = {
      show: false,
      portfolioType: null,
      symbol: null,
      portfolio: null,
      operationType: 'Buy',
      symbolLoading: false,
      symbolError: null,
      createOperationError: null,
      createCashOperationError: null,
      tickerValue: null,
      isCashTransaction: false,
      currency: '',
      isSubmitting: false,
      multipleTransactions: false,
      leagueId: null,
      league: null,
      invitationId: null,
      shouldCheckForLineRule: true,
    };
  },
  RESET_CREATE_PORTFOLIO_OPERATION_MODAL_ON_OPERATION_CHANGE: (state) => {
    state.createPortfolioOperationModal = {
      portfolioType: null,
      symbol: null,
      portfolio: null,
      operationType: 'Buy',
      symbolLoading: false,
      symbolError: null,
      createOperationError: null,
      createCashOperationError: null,
      tickerValue: null,
      isCashTransaction: false,
      currency: '',
      isSubmitting: false,
      multipleTransactions: false,
      shouldCheckForLineRule: true,
    };
  },
  REMOVE_SYMBOL_FROM_PORTFOLIO_OPERATION: (state) => {
    state.createPortfolioOperationModal.symbol = null;
    state.createPortfolioOperationModal.tickerValue = null;
  },
  REMOVE_SYMBOL_FROM_ORDER_OPERATION: (state) => {
    state.createOrderTransactionModal.symbol = null;
    state.createOrderTransactionModal.tickerValue = null;
  },
  SUBMIT_PORTFOLIO_OPERATION_FORM: (state, payload) => {
    state.createPortfolioOperationModal.isSubmitting = true;
    state.createPortfolioOperationModal.multipleTransactions = payload;
  },
  RESET_SUBMIT_OPERATION_STATE: (state) => {
    state.createPortfolioOperationModal.isSubmitting = false;
    state.createPortfolioOperationModal.multipleTransactions = false;
  },
  HANDLE_SHOW_CREATE_PORTFOLIO_OPERATION_MODAL: (state, payload) => {
    if ('isCashTransaction' in payload) {
      state.createPortfolioOperationModal.isCashTransaction =
        payload.isCashTransaction;
    } else {
      state.createPortfolioOperationModal.isCashTransaction = false;
    }
    if ('currency' in payload) {
      state.createPortfolioOperationModal.currency = payload.currency;
    }

    if (!state.createPortfolioOperationModal.isCashTransaction) {
      state.createPortfolioOperationModal.symbol = payload.symbol;
      state.createPortfolioOperationModal.tickerValue = payload.tickerValue ?? {
        high: 0,
        low: 0,
      };
    }

    state.createPortfolioOperationModal.show = payload.show;

    if (payload.show) {
      state.openModals.push(ModalStateNames.TransactionModal);
    }

    if ('shouldShowOperationSwitcher' in payload) {
      state.createPortfolioOperationModal.shouldShowOperationSwitcher =
        payload.shouldShowOperationSwitcher;
    }
    if ('shouldShowOperationButtons' in payload) {
      state.createPortfolioOperationModal.shouldShowOperationButtons =
        payload.shouldShowOperationButtons;
    }
    if ('shouldShowTickerCard' in payload) {
      state.createPortfolioOperationModal.shouldShowTickerCard =
        payload.shouldShowTickerCard;
    }
    if ('shouldCheckForLineRule' in payload) {
      state.createPortfolioOperationModal.shouldCheckForLineRule =
        payload.shouldCheckForLineRule;
    }
    state.createPortfolioOperationModal.portfolioType =
      payload.portfolioType ?? 'Stock';
    state.createPortfolioOperationModal.portfolio = payload.portfolio;
    state.createPortfolioOperationModal.operationType =
      payload.operationType ?? 'Buy';
    state.createPortfolioOperationModal.createOperationLoading = false;
    state.createPortfolioOperationModal.stocksPage =
      payload.stocksPage ?? false;
  },
  HANDLE_SHOW_CREATE_ORDERBOOK_OPERATION_MODAL: (state, payload) => {
    if ('currency' in payload) {
      state.createPortfolioOperationModal.currency = payload.currency;
    }

    state.createOrderTransactionModal.show = payload.show;

    if (payload.show) {
      state.openModals.push(ModalStateNames.OrderBookModal);
    }
    state.createOrderTransactionModal.portfolio = payload.portfolio;

    if (!state.createOrderTransactionModal.isCashTransaction) {
      state.createOrderTransactionModal.symbol = payload.symbol;
      state.createOrderTransactionModal.tickerValue = payload.tickerValue ?? {
        high: 0,
        low: 0,
      };
    }
    state.createOrderTransactionModal.operationType =
      payload.operationType ?? 'Buy';

    /* if ('shouldCheckForLineRule' in payload) {
      state.createPortfolioOperationModal.shouldCheckForLineRule =
        payload.shouldCheckForLineRule;
    }
    state.createPortfolioOperationModal.portfolioType =
      payload.portfolioType ?? 'Stock';
    state.createPortfolioOperationModal.portfolio = payload.portfolio;
    state.createPortfolioOperationModal.operationType =
      payload.operationType ?? 'Buy';
    state.createPortfolioOperationModal.createOperationLoading = false;
    state.createPortfolioOperationModal.stocksPage =
      payload.stocksPage ?? false; */
  },
  UPDATE_PORTFOLIO_OPERATION_LINE_RULE_FLAG(state, payload) {
    state.createPortfolioOperationModal.shouldCheckForLineRule = payload;
  },
  HANDLE_SET_HELP_CENTER: (state, payload) => {
    state.helpCenterObjectRes = { ...payload };
  },
  HANDLE_SET_SHOW_PROFILE_CARD: (state, payload) => {
    state.showProfileCardRes = { ...payload };
  },
  SET_OPERATION_SYMBOL(state, payload) {
    state.createPortfolioOperationModal.symbol = payload;
  },
  SET_ORDER_SYMBOL(state, payload) {
    state.createOrderTransactionModal.symbol = payload;
  },
  GET_TICKER_VALUE_INIT(state) {
    state.createPortfolioOperationModal.tickerValue = null;
  },
  GET_TICKER_VALUE_SUCCESS(state, payload) {
    state.createPortfolioOperationModal.tickerValue = payload;
    if (state.createOrderModal) state.createOrderModal.tickerValue = payload;
  },
  SET_CREATE_OPERATION_MODAL_PORTFOLIO(state, portfolio) {
    state.createPortfolioOperationModal.portfolio = portfolio;
  },
  SET_CREATE_ORDER_MODAL_PORTFOLIO(state, portfolio) {
    state.createOrderTransactionModal.portfolio = portfolio;
  },
  SET_NO_DATA_AT_DATE_ERROR(state, value) {
    state.showNoDataAtDateError = value;
  },

  // Portfolio empty state modal
  SHOW_PORTFOLIO_EMPTY_STATE_MODAL(state) {
    if (!state.portfolioEmptyStateModal.show) {
      state.openModals.push(ModalStateNames.PortfolioEmptyStateModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PortfolioEmptyStateModal
      );
    }
    state.portfolioEmptyStateModal.show = !state.portfolioEmptyStateModal.show;
  },

  // Klipy Modal
  SET_LAST_KLIPY_TRENDING_SEARCH(state) {
    state.klipyModal.lastKlipyTrendingSearch = this.$dayjs();
  },

  // Compare Tickers Modal
  SET_COMPARE_TICKERS_MODAL(state, payload) {
    if (payload.show) {
      state.openModals.push(ModalStateNames.CompareTickersModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.CompareTickersModal
      );
    }
    state.compareTickersModal.show = payload.show;
    state.compareTickersModal.numberOfItemsInComparison =
      payload.numberOfItemsInComparison;
    state.compareTickersModal.selectedTicker = payload.selectedTicker;
  },

  // Team Portfolio Share Modal
  TOGGLE_SHOW_PORTFOLIO_SHARE_MODAL(state) {
    if (!state.manageTeamPortfolioModal.show) {
      state.openModals.push(ModalStateNames.PortfolioShareModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PortfolioShareModal
      );
    }
    state.manageTeamPortfolioModal.show = !state.manageTeamPortfolioModal.show;
  },

  // Compare Portfolios Modal
  SET_COMPARE_PORTFOLIOS_MODAL(state, payload) {
    if (payload.show) {
      state.openModals.push(ModalStateNames.ComparePortfolioModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.ComparePortfolioModal
      );
    }
    state.comparePortfoliosModal.show = payload.show;
    if (state.comparePortfoliosModal.show) {
      state.comparePortfoliosModal.isMyPortfolio = payload.isMyPortfolio;
      state.comparePortfoliosModal.numberOfItemsInComparison =
        payload.numberOfItemsInComparison;
    } else {
      state.comparePortfoliosModal.isMyPortfolio = false;
      state.numberOfItemsInComparison = 0;
    }
  },

  // Create League Modal
  TOGGLE_SHOW_CREATE_LEAGUE_MODAL(state) {
    if (!state.createLeagueModal.show) {
      state.openModals.push(ModalStateNames.CreateLeagueModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.CreateLeagueModal
      );
    }
    state.createLeagueModal.show = !state.createLeagueModal.show;
  },

  HIDE_ALL_MODALS(state) {
    (state.showMobileSidebar = false), (state.showCreatePostModal.show = false);
    state.showImageSliderModal.show = false;
    state.showSelectProfileModal = false;
    state.createPortfolioModal.show = false;
    state.showLegalDisclaimerModal = false;
    state.passwordResetModal.show = false;
    state.createPortfolioOperationModal.show = false;
    state.createOrderTransactionModal.show = false;
    state.helpCenterObjectRes.show = false;
    state.portfolioEmptyStateModal.show = false;
    state.klipyModal.show = false;
    state.compareTickersModal.show = false;
    state.comparePortfoliosModal.show = false;
    state.manageTeamPortfolioModal.show = false;
    state.createLeagueModal.show = false;
    state.companyTickersListModal.show = false;
    state.createOrderModal.show = false;
  },
  SHOW_PORTFOLIO_ASSET_OPERATION_MODAL(state, payload) {
    state.showPortfolioAssetOperationModalFooter = payload;
  },

  CLOSE_EMAIL_CONFIRMATION_BANNER(state) {
    state.hasClosedEmailConfirmationBanner = true;
  },

  SHOW_COMPANY_TICKERS_LIST_MODAL(state, payload) {
    if (payload) {
      state.openModals.push(ModalStateNames.CompanyTickersListModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.CompanyTickersListModal
      );
    }
    state.companyTickersListModal.show = payload;
  },

  TOGGLE_NOTIFICATIONS_CENTER_DRAWER(state, payload) {
    if (payload) {
      state.openModals.push(ModalStateNames.NotificationCenterDrawer);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.NotificationCenterDrawer
      );
    }
    state.notificationsCenterMenuDrawer.show = payload;
  },

  TOGGLE_PORTFOLIO_OPTIONS_DRAWER(state, payload) {
    if (payload) {
      state.openModals.push(ModalStateNames.PortfolioOptionsDrawer);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PortfolioOptionsDrawer
      );
    }
    state.portfolioOptionsDrawer.show = payload;
  },

  TOGGLE_PORTFOLIO_GUIDE_DRAWER(state, payload) {
    if (payload) {
      state.openModals.push(ModalStateNames.PortfolioGuideDrawer);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PortfolioGuideDrawer
      );
    }
    state.portfolioGuideDrawer.show = payload;
  },

  TOGGLE_PORTFOLIO_GUIDE_MODAL(state, payload) {
    if (payload) {
      state.openModals.push(ModalStateNames.PortfolioGuideModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PortfolioGuideModal
      );
    }
    state.portfolioGuideModal.show = payload;
  },

  TOGGLE_HOME_PAGE_GUIDE_DRAWER(state, payload) {
    if (payload) {
      state.openModals.push(ModalStateNames.HomePageGuideDrawer);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.HomePageGuideDrawer
      );
    }
    state.homePageGuideDrawer.show = payload;
  },
  TOGGLE_MOBILE_SIDEBAR(state) {
    state.mobileSidebar.show = !state.mobileSidebar.show;
  },
  TOGGLE_PORTFOLIO_OPERATION_CONFIRMATION_COMPONENT(state, payload) {
    state.portfolioOperationConfirmationComponent.show = payload.show;

    if (payload.show) {
      state.openModals.push(ModalStateNames.OperationConfirmationComponent);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.OperationConfirmationComponent
      );
    }

    if ('itemPayload' in payload)
      state.portfolioOperationConfirmationComponent.itemPayload =
        payload.itemPayload;

    if ('operationPayload' in payload)
      state.portfolioOperationConfirmationComponent.operationPayload =
        payload.operationPayload;

    if ('itemId' in payload)
      state.portfolioOperationConfirmationComponent.itemId = payload.itemId;

    if ('isPublic' in payload)
      state.portfolioOperationConfirmationComponent.isPublic = payload.isPublic;

    if ('itemCountCondition' in payload)
      state.portfolioOperationConfirmationComponent.itemCountCondition =
        payload.itemCountCondition;

    if ('allocationCondition' in payload)
      state.portfolioOperationConfirmationComponent.allocationCondition =
        payload.allocationCondition;

    if ('transactionModalShouldStayOpen' in payload) {
      state.portfolioOperationConfirmationComponent.transactionModalShouldStayOpen =
        payload.transactionModalShouldStayOpen;
    }

    if ('lineRuleLimit' in payload) {
      state.portfolioOperationConfirmationComponent.lineRuleLimit =
        payload.lineRuleLimit;
    }
  },

  //Order modal
  HANDLE_SHOW_CREATE_ORDER_MODAL: (state, payload) => {
    if ('isCashTransaction' in payload) {
      state.createOrderModal.isCashTransaction = payload.isCashTransaction;
    } else {
      state.createOrderModal.isCashTransaction = false;
    }
    if ('currency' in payload) {
      state.createOrderModal.currency = payload.currency;
    }

    if (!state.createOrderModal.isCashTransaction) {
      state.createOrderModal.symbol = payload.symbol;
      state.createOrderModal.tickerValue = payload.tickerValue ?? {
        high: 0,
        low: 0,
      };
    }

    state.createOrderModal.show = payload.show;

    if (payload.show) {
      state.openModals.push(ModalStateNames.OrderModal);
    }

    if ('shouldShowOperationSwitcher' in payload) {
      state.createOrderModal.shouldShowOperationSwitcher =
        payload.shouldShowOperationSwitcher;
    }
    if ('shouldShowOperationButtons' in payload) {
      state.createOrderModal.shouldShowOperationButtons =
        payload.shouldShowOperationButtons;
    }
    if ('shouldShowTickerCard' in payload) {
      state.createOrderModal.shouldShowTickerCard =
        payload.shouldShowTickerCard;
    }
    if ('shouldCheckForLineRule' in payload) {
      state.createOrderModal.shouldCheckForLineRule =
        payload.shouldCheckForLineRule;
    }
    state.createOrderModal.portfolioType = payload.portfolioType ?? 'Stock';
    state.createOrderModal.portfolio = payload.portfolio;
    state.createOrderModal.operationType = payload.operationType ?? 'Buy';
    state.createOrderModal.createOperationLoading = false;
    state.createOrderModal.stocksPage = payload.stocksPage ?? false;
  },
  RESET_CREATE_ORDER_MODAL: (state) => {
    const index = state.openModals.indexOf(ModalStateNames.OrderModal);
    if (index !== -1) state.openModals.splice(index, 1);
    state.createOrderModal = {
      show: false,
      portfolioType: null,
      symbol: null,
      portfolio: null,
      operationType: 'Buy',
      symbolLoading: false,
      symbolError: null,
      createOperationError: null,
      createCashOperationError: null,
      tickerValue: null,
      isCashTransaction: false,
      currency: '',
      isSubmitting: false,
      multipleTransactions: false,
      leagueId: null,
      league: null,
      invitationId: null,
      shouldCheckForLineRule: true,
    };
  },
  RESET_ORDER_MODAL_ON_OPERATION_CHANGE: (state) => {
    state.createOrderModal = {
      portfolioType: null,
      symbol: null,
      portfolio: null,
      operationType: 'Buy',
      symbolLoading: false,
      symbolError: null,
      createOperationError: null,
      createCashOperationError: null,
      tickerValue: null,
      isCashTransaction: false,
      currency: '',
      isSubmitting: false,
      multipleTransactions: false,
      shouldCheckForLineRule: true,
    };
  },
  SET_ORDER_MODAL_PORTFOLIO(state, portfolio) {
    state.createOrderModal.portfolio = portfolio;
  },
  SET_ORDER_MODAL_OPERATION_SYMBOL(state, payload) {
    state.createOrderModal.symbol = payload;
  },
  REMOVE_SYMBOL_FROM_ORDER_MODAL_OPERATION: (state) => {
    state.createOrderModal.symbol = null;
    state.createOrderModal.tickerValue = null;
  },
  RESET_SUBMIT_ORDER_MODAL_STATE: (state) => {
    state.createOrderModal.isSubmitting = false;
    state.createOrderModal.multipleTransactions = false;
  },

  RESET_PORTFOLIO_OPERATION_CONFIRMATION_COMPONENT(state) {
    state.portfolioOperationConfirmationComponent = {
      show: false,
      itemPayload: null,
      operationPayload: null,
      itemId: null,
      isPublic: false,
      itemCountCondition: false,
      allocationCondition: false,
      transactionModalShouldStayOpen: false,
      lineRuleLimit: null,
    };
  },

  HIDE_TOP_MODAL(state) {
    const id = state.openModals[state.openModals.length - 1];
    if (!id) return;

    const slice = state[id];
    if (slice && Object.prototype.hasOwnProperty.call(slice, 'show')) {
      slice.show = false;
    }

    state.openModals.pop();
  },
  HANDLE_SHOW_PORTFOLIO_SETTINGS_MODAL(state, payload) {
    state.portfolioSettingsModal = payload;

    if (payload.show) {
      state.openModals.push(ModalStateNames.PortfolioSettingsModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PortfolioSettingsModal
      );
    }
  },
  RESET_UNRANKED_PORTFOLIO_CONFIRMATION_COMPONENT(state) {
    state.unrankedPortfolioConfirmationComponent = {
      show: false,
      itemPayload: null,
      operationPayload: null,
      itemId: null,
      isPublic: false,
      itemCountCondition: false,
      allocationCondition: false,
      transactionModalShouldStayOpen: false,
    };
  },
  TOGGLE_UNRANKED_PORTFOLIO_CONFIRMATION_COMPONENT(state, payload) {
    state.unrankedPortfolioConfirmationComponent.show = payload.show;

    if (payload.show) {
      state.openModals.push(
        ModalStateNames.UnrankedPortfolioConfirmationComponent
      );
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.UnrankedPortfolioConfirmationComponent
      );
    }

    if ('itemPayload' in payload)
      state.unrankedPortfolioConfirmationComponent.itemPayload =
        payload.itemPayload;

    if ('operationPayload' in payload)
      state.unrankedPortfolioConfirmationComponent.operationPayload =
        payload.operationPayload;

    if ('itemId' in payload)
      state.unrankedPortfolioConfirmationComponent.itemId = payload.itemId;

    if ('isPublic' in payload)
      state.unrankedPortfolioConfirmationComponent.isPublic = payload.isPublic;

    if ('itemCountCondition' in payload)
      state.unrankedPortfolioConfirmationComponent.itemCountCondition =
        payload.itemCountCondition;

    if ('allocationCondition' in payload)
      state.unrankedPortfolioConfirmationComponent.allocationCondition =
        payload.allocationCondition;

    if ('transactionModalShouldStayOpen' in payload) {
      state.unrankedPortfolioConfirmationComponent.transactionModalShouldStayOpen =
        payload.transactionModalShouldStayOpen;
    }
  },
  TOGGLE_NO_ELIGIBLE_PORTFOLIOS_DRAWER(state, payload) {
    state.noEligiblePortfoliosDrawer.show = payload;
  },
  TOGGLE_NO_ELIGIBLE_PORTFOLIO_MODAL(state, payload) {
    state.noEligiblePortfolioModal.show = payload;
  },
  TOGGLE_QUICKSTART_COMPLETION_MODAL(state, payload) {
    // While there isn't an actual risk here, this safeguard prevents unnecessary modal toggling when the action is triggered from multiple places
    if (state.quickstartCompletionModal.show === payload) return;

    state.quickstartCompletionModal.show = payload;
  },
  HANDLE_SHOW_PORTFOLIO_SELECTOR_MODAL(state, payload) {
    state.portfolioSelectorModal = payload;

    if (payload.show) {
      state.openModals.push(ModalStateNames.PortfolioSelectorModal);
    } else {
      state.openModals = state.openModals.filter(
        (m) => m !== ModalStateNames.PortfolioSelectorModal
      );
    }
  },
  RESET_PORTFOLIO_SELECTOR_MODAL: (state) => {
    const index = state.openModals.indexOf(
      ModalStateNames.PortfolioSelectorModal
    );
    if (index !== -1) state.openModals.splice(index, 1);
    state.portfolioSelectorModal = {
      show: false,
      portfolios: [],
      symbol: null,
      selectedTicker: null,
      portfolioType: null,
      selectedPortfolio: null,
    };
  },
  OPEN_PORTFOLIO_SELECTOR_MODAL(state, payload) {
    // When the modal is shown, its previous state is not kept - it's shown as if
    // for the first time. In case some state should be kept, this will require a refactor.
    state.portfolioSelectorModal = {
      show: true,
      portfolios: payload.portfolios ?? [],
      symbol: payload.symbol ?? null,
      selectedTicker: null,
      portfolioType: null,
      selectedPortfolio: null,
    };
    state.openModals.push(ModalStateNames.PortfolioSelectorModal);
  },
  CLOSE_PORTFOLIO_SELECTOR_MODAL(state) {
    // selectedTicker/selectedPortfolio are intentionally left as it is: onContinue()
    // closes the modal then emits 'continue', whose handler (handleOpenTransactionModal)
    // reads them right after ==> resetting here would wipe that data before it's used.
    state.portfolioSelectorModal.show = false;
    state.openModals = state.openModals.filter(
      (m) => m !== ModalStateNames.PortfolioSelectorModal
    );
  },
  SET_PORTFOLIO_SELECTOR_SYMBOL(state, symbol) {
    state.portfolioSelectorModal.symbol = symbol;
  },
  SET_SELECTED_TICKER_AND_PORTFOLIO_TYPE(state, payload) {
    state.portfolioSelectorModal.selectedTicker = payload.selectedTicker;
    state.portfolioSelectorModal.portfolioType = payload.portfolioType;
  },
  SET_SELECTED_PORTFOLIO(state, portfolio) {
    state.portfolioSelectorModal.selectedPortfolio = portfolio;
  },
  TOGGLE_SHOW_TRANSACTION_TYPES(state, payload) {
    state.showTransactionTypesModal = payload;
  },
};
